import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetTagListQuery, Tag, useAssignHealthChecksTagsMutation } from '../../../generated/graphql';
import { FormMultiSelect, FormCheckbox } from '../../form';
import styles from './AddHealthChecksTagsDialog.module.css';

type AddHealthChecksTagsDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
    ids: string[];
};

const AddHealthChecksTagsDialog = (props: AddHealthChecksTagsDialogProps) => {
    const { ids, style, visible, onClose } = props;
    const [assignHealthChecksTags, assignHealthChecksTagsResult] = useAssignHealthChecksTagsMutation();
    const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
    const [overwrite, setOverwrite] = useState(false);
    const [validationError, setValidationError] = useState('');
    const tags = useGetTagListQuery({
        fetchPolicy: "no-cache",
        variables: { contains: "" }
    });

    const sortedTags = [...(tags.data?.TagList?.nodes || [])].sort((a, b) =>
        (a?.fullName || "") < (b?.fullName || "") ? -1 : (a?.fullName || "") > (b?.fullName || "") ? 1 : 0
    );

    const handleSubmit = () => {
        if (selectedTags.length === 0) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        const tagIds = selectedTags.map(t => t.id || "");
        assignHealthChecksTags({
            variables: { ids, tagIds, overwrite }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Assign Health Check Tags"
            type="OkCancel"
            isLoading={assignHealthChecksTagsResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.AddHealthChecksTagsDialog}
            style={style}
            data-testid="AddHealthChecksTagsDialog">
            <FormMultiSelect
                label="Tags"
                name="tags"
                value={selectedTags}
                onChange={(v) => setSelectedTags(v as Tag[])}
                options={sortedTags}
                textField="fullName"
            />
            <FormCheckbox
                label="Overwrite"
                name="overwrite"
                checked={overwrite}
                onChange={setOverwrite}
            />
        </DialogBase>
    );
};

export default AddHealthChecksTagsDialog;